import clsx from 'clsx';
import { initials } from '@gallarday/core';
import { docUrl } from '../api/hooks.ts';
import type { PersonLite } from '../api/types.ts';

/**
 * Retrato de una persona: su foto si existe; si no, un monograma con el tinte de su línea
 * (añil para hombres, cochinilla para mujeres).
 */
export function PersonAvatar({ person, treeId, size = 44, className, ring }: {
  person: Pick<PersonLite, 'givenNames' | 'paternalSurname' | 'maternalSurname' | 'sex' | 'photoDocumentId'>;
  treeId: string;
  size?: number;
  className?: string;
  ring?: boolean;
}) {
  const tint = person.sex === 'M' ? 'var(--male)' : person.sex === 'F' ? 'var(--female)' : 'var(--ink-faint)';
  return (
    <span
      className={clsx('relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-serif font-semibold', className)}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.36,
        color: tint,
        background: `color-mix(in oklab, ${tint} 14%, var(--surface))`,
        boxShadow: ring ? `0 0 0 2px var(--surface), 0 0 0 4px ${tint}` : undefined,
      }}
      aria-hidden
    >
      {person.photoDocumentId ? (
        <img src={docUrl(treeId, person.photoDocumentId)} alt="" className="size-full object-cover" loading="lazy" decoding="async" />
      ) : (
        initials(person)
      )}
    </span>
  );
}
